import React from 'react'
import BOD1 from '../../Images/HR/BODMember/NageshPokharel.jpg'
import BOD2 from '../../Images/HR/BODMember/MatrikaPrasadDhakal.jpg'
import BOD3 from '../../Images/HR/BODMember/ArjunKumarTimsina.JPG'
import BOD4 from '../../Images/HR/BODMember/AnjanaSangraula.jpeg'
import BOD5 from '../../Images/HR/BODMember/HiranyaKalakheti.JPG'
import BOD6 from '../../Images/HR/BODMember/RabindraKrishnaShrestha.jpg'
import BOD7 from '../../Images/HR/BODMember/BishnuKumariRai.jpg'
import BOD8 from '../../Images/HR/BODMember/BhaktiPrasadDhakal.jpg'
import BOD9 from '../../Images/HR/BODMember/PostKumarShrestha.jpg'
import BOD10 from '../../Images/HR/BODMember/BinaDhakal.jpg'
import BOD11 from '../../Images/Default/CommonImg.png'
import '../../css/BODmember.css'
import Aos from 'aos'

const BoardOfDirectors = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    const BodMembersList = [
        {
            id: '1',
            memName: 'मातृकाप्रसाद ढकाल',
            post: 'उपाध्यक्ष',
            memImg: BOD2,
            phoneno: '९८४२५६६८४८'
        },
        {
            id: '2',
            memName: 'अर्जुनकुमार खत्री तिम्सिना',
            post: 'सचिव',
            memImg: BOD3,
            phoneno: '९८४२०३६४०९'
        },
        {
            id: '3',
            memName: 'अञ्जना संगौला',
            post: 'सह–सचिव',
            memImg: BOD4,
            phoneno: '९८४२२५२५६५'
        },
        {
            id: '4',
            memName: 'हिरण्य कालाखेती',
            post: 'कोषाध्यक्ष',
            memImg: BOD5,
            phoneno: '९८५२६३३६९९'
        },
        {
            id: '5',
            memName: 'रवीन्द्रकृष्ण श्रेष्ठ',
            post: 'सदस्य',
            memImg: BOD6,
            phoneno: '९८४२०३४५५०'
        },
        {
            id: '6',
            memName: 'बिष्णुकुमारी राई',
            post: 'सदस्य',
            memImg: BOD7,
            phoneno: '९८१४३२७१४६'
        },
        {
            id: '7',
            memName: 'भक्तिप्रसाद ढकाल',
            post: 'सदस्य',
            memImg: BOD8,
            phoneno: '९८४२३२५१८६'
        },
        {
            id: '8',
            memName: 'पोष्टकुमार श्रेष्ठ',
            post: 'सदस्य',
            memImg: BOD9,
            phoneno: '९८४२१२५६३३'
        },
        {
            id: '9',
            memName: 'बीना ढकाल',
            post: 'सदस्य',
            memImg: BOD10,
            phoneno: '९८४२०५८३४४'
        },
        {
            id: '10',
            memName: '-',
            post: '-',
            memImg: BOD11,
            phoneno: '-'
        },
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>कनकलक्ष्मी साकोस :: संचालक समिति</h2><hr />
                        </div>
                    </div>
                    <div className='president1' data-aos='fade-right'>
                        <div className='president-img'>
                            <img src={BOD1} alt='BOD' />
                        </div>
                        <div className='president-detail'>
                            <h2>नागेश पोखरेल</h2>
                            <p>९८५२०४६२१९</p>
                            <h3>अध्यक्ष</h3>
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {BodMembersList.map((item, index) => {
                            return (
                                <div className='president2-body'>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='BOD' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <p>{item.phoneno}</p>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default BoardOfDirectors